function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "WAREMA_logo",
  transform: "translate(-15.991 -16.221)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path3769",
  d: "M150.859,295.427h-5.686l.261-8.8-5.784,8.8H133.8l-.384-13.152h5.875l-.517,8.36,5.419-8.36h5.713l-.3,8.36,5.12-8.36h5.28l-9.147,13.152",
  transform: "translate(-99.215 -224.794)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path3771",
  d: "M299.931,287.533c-.676,2.006-1.95,3.855-4.2,3.855-1.083,0-1.687-.7-1.335-1.745.519-1.536,2.426-2.137,4.078-2.137.162,0,.867,0,1.454.027m3.433,6.2a24.176,24.176,0,0,1,1.083-3.854l1.475-4.375c.658-1.953.577-3.074-.2-3.907-.885-.989-2.694-1.328-5.347-1.328-2.9,0-7.178.572-8.527,4.088h5.28a2.486,2.486,0,0,1,2.546-1.772c1.408,0,1.572,1.042,1.212,2.11l-.273.807H299.18c-4.847,0-8.81.912-10,4.453-.913,2.707.615,4.036,3.649,4.036a7.237,7.237,0,0,0,5.753-2.37,9.529,9.529,0,0,0-.386,2.11h5.171",
  transform: "translate(-230.598 -223.098)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path3773",
  d: "M802.435,287.533c-.676,2.006-1.949,3.855-4.2,3.855-1.083,0-1.685-.7-1.333-1.745.518-1.536,2.426-2.137,4.076-2.137.164,0,.867,0,1.454.027m3.434,6.2a24.015,24.015,0,0,1,1.083-3.854l1.475-4.375c.659-1.953.575-3.074-.2-3.907-.885-.989-2.694-1.328-5.347-1.328-2.9,0-7.179.572-8.527,4.088h5.28a2.489,2.489,0,0,1,2.548-1.772c1.408,0,1.57,1.042,1.211,2.11l-.273.807h-1.436c-4.847,0-8.809.912-10,4.453-.915,2.707.614,4.036,3.648,4.036a7.24,7.24,0,0,0,5.754-2.37,9.445,9.445,0,0,0-.386,2.11h5.171",
  transform: "translate(-655.174 -223.098)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path3775",
  d: "M417.093,286.008a4.883,4.883,0,0,0-3.375,1.25,6.645,6.645,0,0,0-1.7,2.968l-1.651,4.9h-5.578l3.136-9.3c.526-1.563.806-2.552,1.164-3.855h5.47c-.1.443-.514,2.005-.715,2.6a6.565,6.565,0,0,1,5.255-2.657,3.068,3.068,0,0,1,.821.052l-1.412,4.193a7.943,7.943,0,0,0-1.41-.155",
  transform: "translate(-328.499 -224.49)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path3777",
  d: "M504.945,285.46h-5.172a3.936,3.936,0,0,1,3.682-2.969c1.626,0,2.14,1.042,1.49,2.969m4.561,2.292a9.267,9.267,0,0,0,.685-3.959c-.285-2.527-2.436-3.7-5.982-3.7-5.336,0-9.065,2.63-10.558,7.058a5.436,5.436,0,0,0,.234,4.765c.906,1.329,2.618,1.953,5.625,1.953a11.643,11.643,0,0,0,6.483-1.64,7.669,7.669,0,0,0,2.868-3.047h-5.172a3.341,3.341,0,0,1-3.247,2.162c-1.924,0-2.171-1.432-1.523-3.594h10.586",
  transform: "translate(-403.228 -222.952)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path3779",
  d: "M624.03,294.3l2.539-7.526c.589-1.745.641-2.865-1.065-2.865-1.76,0-2.517,1.12-3.13,2.943l-2.512,7.448h-5.578l2.53-7.5a5.017,5.017,0,0,0,.4-1.822c-.051-.653-.444-1.1-1.392-1.1a2.925,2.925,0,0,0-2.274,1.12,5.163,5.163,0,0,0-.9,1.8l-2.529,7.5h-5.578l3.065-9.089c.483-1.433.869-2.657,1.234-4.063h5.5c-.067.365-.4,1.588-.53,2.058a7.581,7.581,0,0,1,5.611-2.265c2.167,0,3.354.649,3.659,2.4a7.75,7.75,0,0,1,5.79-2.4c2.464,0,3.726.833,3.939,2.369a6.928,6.928,0,0,1-.513,3.047l-2.679,7.943H624.03",
  transform: "translate(-497.272 -223.667)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path3781",
  d: "M332.694,17.094,210.835,22.027l1.959-5.806H333.719l-1.025.873",
  transform: "translate(-164.627)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path3783",
  d: "M316.561,63.826,194.7,68.759l1.959-5.806H317.587l-1.027.873",
  transform: "translate(-150.997 -39.485)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path3785",
  d: "M300.71,110.556l-121.859,4.935,1.959-5.808H301.735l-1.025.873",
  transform: "translate(-137.604 -78.968)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path3787",
  d: "M284.858,157.288,163,162.223l1.959-5.808H285.885l-1.027.873",
  transform: "translate(-124.21 -118.453)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path3789",
  d: "M33.157,549.75l121.859-4.935-1.959,5.808H32.132l1.025-.873",
  transform: "translate(-13.638 -446.619)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path3791",
  d: "M269.178,204.028l-121.859,4.935,1.958-5.806H270.2l-1.025.872",
  transform: "translate(-110.962 -157.945)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path3793",
  d: "M49,503.018l121.858-4.935-1.958,5.808H47.976L49,503.018",
  transform: "translate(-27.025 -407.135)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path3795",
  d: "M17.018,596.481l121.858-4.935-1.958,5.808H15.991l1.027-.873",
  transform: "translate(0 -486.103)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path3797",
  d: "M64.853,456.284l121.859-4.933-1.959,5.806H63.828l1.025-.873",
  transform: "translate(-40.418 -367.65)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path3799",
  d: "M80.542,409.546,202.4,404.61l-1.959,5.808H79.517l1.025-.872",
  transform: "translate(-53.674 -328.158)"
}));

var SvgWarema = function SvgWarema(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153.101,
    height: 95.029,
    viewBox: "0 0 153.101 95.029",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWarema, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warema.cfbc96b9.svg";
export { ForwardRef as ReactComponent };